import { JournalEntry, JournalEntryLine } from "./journalEntry";

export enum ManualJournalEntrySource {
    USER = "user",
    API = "api",
    RECURRING = "recurring",
    QUICKBOOKS = "quickbooks",
    QUICKBOOKS_DESKTOP = "quickbooks-desktop",
    XERO = "xero",
    CONSOLIDATION_ELIMINATING = "consolidation-eliminating",
}

export const IMPORTED_MANUAL_JOURNAL_ENTRY_SOURCES = [
    ManualJournalEntrySource.QUICKBOOKS,
    ManualJournalEntrySource.QUICKBOOKS_DESKTOP,
    ManualJournalEntrySource.XERO,
];

export type ManualJournalEntryNew = Omit<
    JournalEntry,
    "source" | "ledgerBasis"
> & {
    financialDocumentIds?: number[];
};

export type ManualJournalEntryLineNew = JournalEntryLine;
